'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getSpm(el) {
  var spm = void 0;
  try {
    spm = window.g_SPM.getParam(el || document.body);
  } catch (e) {
    // ...
  }
  return spm;
}

function getSpmString(el) {
  var spmObj = getSpm(el);
  return spmObj ? spmObj.a + '.' + spmObj.b + '.' + spmObj.c + '.' + spmObj.d + '.' + spmObj.e : '';
}

exports.getSpmString = getSpmString;
exports['default'] = getSpm;